import { render } from "./RoleDistributionComparisonBlock.vue?vue&type=template&id=176db7a8&scoped=true"
import script from "./RoleDistributionComparisonBlock.vue?vue&type=script&lang=js"
export * from "./RoleDistributionComparisonBlock.vue?vue&type=script&lang=js"

import "./RoleDistributionComparisonBlock.vue?vue&type=style&index=0&id=176db7a8&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176db7a8"]])

export default __exports__